const MAPS_URI = Platform.uris.maps;

export { MAPS_URI };
